import { sendNewRelicError } from '../../new-relic';
export function parseJson(message, next) {
  try {
    var parsed = JSON.parse(message.data);
    next(parsed);
  } catch (error) {
    sendNewRelicError('parse web socket message failed', {
      message: error
    });
  }
}